import { useEffect, useRef, useState } from "react";

export const useGetWidthWithOverflow = <T extends HTMLElement>(initialRefValue: T, initiallyFocus = true) => {
    const ref = useRef<T>(initialRefValue);
    const [width, setWidth] = useState<number>();

    useEffect(() => {
        // focus on the input
        if (initiallyFocus) {
            ref.current?.focus();
        }
        if (ref.current) {
            // Resize column to fit cell editor completely, so it is not clipped in the overflow
            ref.current.style.overflowY = "visible";
            ref.current.style.width = "auto";
            const { width } = ref.current.getBoundingClientRect();

            setWidth(width);
        }
    }, [ref.current]);

    return { ref, width };
};
